import { Dialog } from "primereact/dialog";
import styled from "styled-components";

export const StyledDialog = styled(Dialog)`
	width: 40rem;
`;
